import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ClockIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ClockIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/clock">
            <path
                id="Vector"
                d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
        </g>
    </SvgIcon>
)
